export default {
	REGULAR_FILTER: '1',
	STANDARDS_FILTER: '2',
}
